import { Permission } from 'shared'
import { CIMSTabs } from 'components/CIMSTabs'
import Levels from './components/Levels'
import Groups from './components/Groups'
import UserRoleSelectProvider from 'components/CIMSSelect/common/UserRoleSelect/UserRoleSelectContext'

const Concurrences: React.FC = () => {
  const Tab = { Levels: 'Levels', Groups: 'Groups' } as const
  return (
    <CIMSTabs
      initialTab={Tab.Levels}
      tabs={[
        {
          component: <Levels />,
          key: Tab.Levels,
          label: Tab.Levels,
          permission: Permission.ViewFDCConcurrenceLevel,
        },
        {
          component: (
            <UserRoleSelectProvider>
              <Groups />
            </UserRoleSelectProvider>
          ),
          key: Tab.Groups,
          label: Tab.Groups,
          permission: Permission.ViewFDCConcurrenceGroup,
        },
      ]}
    />
  )
}

export default Concurrences
